// UpgradePopup.js
import React from "react";
import { useNavigate } from "react-router-dom";

const UpgradePopup = () => {
  const navigate = useNavigate();

  // Handler for the Upgrade button click
  const handleUpgradeClick = () => {
    // Navigate to the billing page
    navigate("/billing");
  };

  return (
    <div
      className="fixed bottom-0 md:left-[250px] right-0 mx-auto max-w-6xl bg-gradient-to-r from-fuchsia-900 to-fuchsia-700 hover:opacity-90 text-white py-4 flex justify-center items-center z-50"
      style={{ display: "block" }}
    >
      <div className="flex justify-between items-center max-w-6xl w-full px-4">
        <div className="text-center md:text-left">
          <h2 className="text-lg font-bold mb-2">Upgrade Your Plan</h2>
          <p className="text-sm mb-4">
            Unlock all the features to get the most out of our platform. Upgrade your plan now!
          </p>
        </div>
        <button
          onClick={handleUpgradeClick}
          className="bg-white text-purple-900 font-semibold px-6 py-2 rounded-md hover:bg-gray-100 transition-all"
        >
          Upgrade Now
        </button>
      </div>
    </div>
  );
};

export default UpgradePopup;
